/**
 * V2 Sale Commissions API client.
 *
 * Comissões do user (afiliado, manager, coproducer, owner) em todos os papéis.
 * Tabela é append-only — reversões geram registros com commission_amount_cents
 * negativo e reverses_commission_id apontando pro original.
 */

import v2Api from './index';

export const saleCommissionsV2API = {
  /**
   * Lista comissões do user autenticado.
   *
   * Query opcional:
   *   status — 'pending' | 'released' | 'reversed' | 'paid_out'
   *
   * Resposta:
   *   { success, commissions: [...], count, aggregates: {
   *       total_cents,
   *       by_status: { pending: { count, total_cents }, released: { ... }, ... }
   *   } }
   */
  listMine: (params = {}) => v2Api.get('/sale-commissions/me', { params }),

  /**
   * Dashboard agregado (substitui /api/commissions/dashboard/:userId V1).
   *
   * Query opcional:
   *   period — dias (default 30)
   *   product — id do produto (filtro opcional, ou 'all')
   *
   * Resposta:
   *   { success, data: {
   *       summary: { total_commissions, total_sales, pending_balance, available_balance },
   *       evolution: { labels, commissions, sales },
   *       distribution: { producer, affiliate, coproducer, manager },
   *       recent_commissions: [...]
   *   } }
   */
  dashboard: (params = {}) => v2Api.get('/sale-commissions/dashboard', { params }),
};

export default saleCommissionsV2API;
